export default __webpack_public_path__ + "images/771f16d920c522a2df20261dd0930a9e.png";